module.exports = __webpack_public_path__ + "img/david.4c292bf3.jpeg";